/* ============================================================
   Best In Beads — Wishlist (localStorage)
   ============================================================ */
(function () {
  var KEY = 'bib_wishlist_v1';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function saveList(arr) { localStorage.setItem(KEY, JSON.stringify(arr)); }

  function toggle(handle) {
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx > -1) { list.splice(idx, 1); } else { list.push(handle); }
    saveList(list);
    updateCounts();
    return idx === -1;
  }

  function updateCounts() {
    var n = getList().length;
    document.querySelectorAll('.wishlist-count').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function syncButtons() {
    var list = getList();
    document.querySelectorAll('.wishlist-btn[data-handle]').forEach(function (btn) {
      var h = btn.dataset.handle;
      if (list.includes(h)) {
        btn.classList.add('wishlisted');
        btn.innerHTML = '&#9829;';
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('wishlisted');
        btn.innerHTML = '&#9825;';
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  function initButtons() {
    document.querySelectorAll('.wishlist-btn[data-handle]').forEach(function (btn) {
      if (btn.dataset.wishlistInit) return;
      btn.dataset.wishlistInit = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var h = btn.dataset.handle;
        var added = toggle(h);
        btn.classList.toggle('wishlisted', added);
        btn.innerHTML = added ? '&#9829;' : '&#9825;';
        var toast = document.getElementById('toast');
        var msg = document.getElementById('toastMsg');
        if (toast && msg) {
          msg.textContent = added ? 'Added to wishlist!' : 'Removed from wishlist';
          toast.classList.add('show');
          setTimeout(function () { toast.classList.remove('show'); }, 2500);
        }
      });
    });
  }

  function renderWishlistPage() {
    var container = document.getElementById('wishlist-products');
    if (!container) return;
    var list = getList();
    if (list.length === 0) { container.innerHTML = emptyHTML(); return; }
    container.innerHTML = '<p class="wishlist-loading">Loading your wishlist…</p>';
    var products = []; var remaining = list.length;
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { products.push(p); check(); })
        .catch(function () { check(); });
    });
    function check() { remaining--; if (remaining === 0) renderProducts(products, container); }
  }

  function emptyHTML() {
    return '<div class="wishlist-empty">'
      + '<div class="wishlist-empty-icon">&#9825;</div>'
      + '<p class="wishlist-empty-title">Your wishlist is empty</p>'
      + '<p class="wishlist-empty-sub">Tap the heart on any product to save it here.</p>'
      + '<a href="/collections" class="btn-primary" style="display:inline-block;margin-top:12px;">Shop Collections</a>'
      + '</div>';
  }

  function getImgSrc(p) {
    /* featured_image is always a direct URL string in /products/{handle}.js */
    if (p.featured_image) return p.featured_image;
    /* fallback: images array can be strings or objects depending on Shopify version */
    if (p.images && p.images.length > 0) {
      var first = p.images[0];
      return typeof first === 'string' ? first : (first.src || '');
    }
    return '';
  }

  function renderProducts(products, container) {
    if (products.length === 0) { container.innerHTML = emptyHTML(); return; }
    var html = '<div class="products-grid">';
    products.forEach(function (p) {
      var img = getImgSrc(p);
      /* ensure protocol so browser doesn't reject protocol-relative URLs */
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var price = '$' + (p.price / 100).toFixed(2);
      var compare = p.compare_at_price && p.compare_at_price > p.price ? '$' + (p.compare_at_price / 100).toFixed(2) : '';
      var title = p.title.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      html += '<div class="prod-card">'
        + '<div class="card-img-wrap">'
        + (img ? '<img src="' + img + '" alt="' + title + '" loading="lazy">' : '<div style="width:100%;height:100%;background:linear-gradient(135deg,#A8705A,#7A4030);"></div>')
        + '<button class="wishlist-btn wishlisted" data-handle="' + p.handle + '" aria-label="Remove from wishlist">&#9829;</button>'
        + '<div class="prod-overlay"><a class="quick-add" href="/products/' + p.handle + '">Quick View</a></div>'
        + '</div>'
        + '<div class="card-body">'
        + '<p class="prod-sub">' + (p.product_type || '') + '</p>'
        + '<h3 class="prod-name"><a href="/products/' + p.handle + '">' + title + '</a></h3>'
        + '<div class="prod-price"><span class="price-sale">' + price + '</span>' + (compare ? '<span class="price-orig">' + compare + '</span>' : '') + '</div>'
        + '</div></div>';
    });
    html += '</div>';
    container.innerHTML = html;
    syncButtons(); initButtons();
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateCounts(); syncButtons(); initButtons(); renderWishlistPage();
  });
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('prod-tab-btn')) {
      setTimeout(function () { syncButtons(); initButtons(); }, 150);
    }
  });
  window.BibWishlist = { toggle: toggle, getList: getList };
}());
